import type { i18n as I18nInstance, TOptions } from 'i18next';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from '../locale/en.json';
import es from '../locale/es.json';
import ru from '../locale/ru.json';

export function createTrajectoryI18n(parentI18n?: I18nInstance): I18nInstance {
  const instance = i18next.createInstance();

  instance.use(initReactI18next).init({
    resources: {
      en: { trajectory: en },
      ru: { trajectory: ru },
      es: { trajectory: es },
    },
    lng: 'en',
    fallbackLng: 'en',
    defaultNS: 'trajectory',
    interpolation: {
      escapeValue: false,
    },
  });

  if (parentI18n) {
    const originalT = instance.t.bind(instance);

    instance.t = ((key: unknown, options?: TOptions | string) => {
      const keyStr = Array.isArray(key) ? String(key[0]) : String(key);

      if (instance.exists(keyStr)) {
        return originalT(key as never, options as never);
      }

      if (parentI18n.exists(keyStr)) {
        return parentI18n.t(keyStr, options as TOptions);
      }

      return originalT(key as never, options as never);
    }) as typeof instance.t;
  }

  return instance;
}
